import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { MAX_ENTITY_COUNT } from '../constants'
import { isClosedShape } from './entityPositions'
import { isIconShape } from './iconShapes'

const isAssignableShape = (shape: VisualShape) =>
  isClosedShape(shape) || isIconShape(shape)

export const getEntityNumberStarts = (
  shapes: VisualShape[],
): Map<string, number> => {
  const starts = new Map<string, number>()
  let next = 1
  for (const shape of [...shapes].reverse()) {
    if (!isAssignableShape(shape)) continue
    const count = Math.min(shape.entity_count ?? 0, MAX_ENTITY_COUNT)
    if (count <= 0) continue
    starts.set(shape.id, next)
    next += count
  }
  return starts
}

export const formatEntityNumberRange = (
  start: number,
  count: number,
): string => {
  if (count <= 1) return String(start)
  return `${start}-${start + count - 1}`
}
